module.exports = __webpack_public_path__ + "img/canot-dots-2.fcdc6b87.png";